import { toast } from "react-toastify";

export const toastOptions = {
  position: "top-center",
  autoClose: 1500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  className: "toast",
  bodyClassName: "toast-body",
  progressClassName: "toast-progress",
};
